import { CategoryType } from "@xs2event/js-lib/api";
import type { FunctionalComponent } from "vue";
import HospitalityIcon from "~icons/material-symbols/local-bar-outline";
import StandingIcon from "~icons/material-symbols/barefoot-outline";
import SeatIcon from "~icons/ic/baseline-event-seat";

// Central label + icon per categoryType, shared between the category perk filters and the category type group headings
export const categoryTypeMeta: Partial<Record<CategoryType, { label: string; icon: FunctionalComponent }>> = {
  [CategoryType.Grandstand]: { label: "Grandstand", icon: SeatIcon },
  [CategoryType.Hospitality]: { label: "Hospitality", icon: HospitalityIcon },
  [CategoryType.OffsiteHospitality]: { label: "Offsite Hospitality", icon: HospitalityIcon },
  [CategoryType.Generaladmission]: { label: "General Admission", icon: StandingIcon },
};

// Display order for categoryType groups/filters: Hospitality > Grandstand > General Admission.
// Types not listed here (e.g. camping, parking) keep whatever order they're encountered in.
const CATEGORY_TYPE_ORDER: CategoryType[] = [
  CategoryType.Generaladmission,
  CategoryType.Grandstand,
  CategoryType.Hospitality,
  CategoryType.OffsiteHospitality,
];

export function categoryTypeRank(categoryType: string): number {
  const index = CATEGORY_TYPE_ORDER.indexOf(categoryType as CategoryType);
  return index === -1 ? CATEGORY_TYPE_ORDER.length : index;
}
